import type { UsContactValues, UsIdentityValues, UsPersonalValues } from "../schemas/us-pre-join.schema.ts";
import styles from "../../../../create-employee/steps/review-step.module.css";

const show = (value?: string) => value?.trim() || "-";
const fields = (items: Array<[string, string]>) => <div className={styles.grid}>{items.map(([label, value]) => <div className={styles.pair} key={label}><p className={`body-sm ${styles.term}`}>{label}</p><p className={styles.desc}>{show(value)}</p></div>)}</div>;

export function UsReviewStep({ personal, contact, identity }: { personal: UsPersonalValues; contact: UsContactValues; identity: UsIdentityValues }) {
  return <div className={styles.sections}>
    <p className={`body-sm ${styles.lead}`}>Review your details before submission.</p>
    <hr className={styles.separator} />
    <section><h3 className={`heading-xs ${styles.sectionTitle}`}>Personal Details</h3>{fields([
      ["First Name", personal.firstName], ["Middle Name", personal.middleName ?? ""], ["Last Name", personal.lastName],
      ["Personal Email", personal.personalEmail], ["Gender", personal.gender],
      ["Date of Birth", personal.dob], ["Date of Joining", personal.joiningDate], ["Marital Status", personal.maritalStatus],
      ["Anniversary Date", personal.anniversaryDate ?? ""],
    ])}</section>
    <hr className={styles.separator} />
    <section><h3 className={`heading-xs ${styles.sectionTitle}`}>Contact Details</h3>{fields([
      ["Contact Number", contact.phoneNumber],     ["Present Address", contact.presentAddress], ["Permanent Address", contact.permanentAddress ?? ""],["Emergency Contact Name", contact.emergencyContactName],
      ["Emergency Contact Number", contact.emergencyContactNumber], ["Relationship with Emergency Contact Person", contact.emergencyRelationship],
  
    ])}</section>
    <hr className={styles.separator} />
    <section><h3 className={`heading-xs ${styles.sectionTitle}`}>Identity Details</h3>{fields([
      ["SSN (Social Security Number)", identity.ssn], ["Passport Number", identity.passportNumber], ["ZIP Code", identity.zipCode],
    ])}</section>
  </div>;
}
